<template>
  <div class="infonews">
    <h1 class="bigtitle">测评智库</h1>
    <div style="display:flex;width: 1300px;" class="personInfo">
      <el-carousel height="380px" style="width:1300px" :loop="true" :autoplay="false">
        <el-carousel-item v-for="item in personPages" :key="item">
          <ul>
            <li v-for="(person,index) in personDatas.slice((item-1)*6,(item-1)*6+6)" :key="index" @click="$router.push(`/MemberRlt?name=${person.name}&code=${person.code}&inqType=gr&comeinbysy=1`)">
              <img :src="`${IP_TEST}/uploads/xlsfile/usepic/${person.picsrc}`" alt="" width="100" height="140"/>
              <div class="info">
                <h2>
                  <span style="color: #2049B2;">{{ person.name }}</span>
                </h2>
                <p>
                  职业名称：<span style="color:#2049B2">{{ person.honoraryTitle }}</span>
                </p>
                <div class="hengxian"></div>
                <p class="sketch">
                  {{ person.sketch }}
                </p>
              </div>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { IP_TEST } from '@/config'
import {getGRMembers } from '@/request/get'
export default {
  name: "PersonRongyu",
  data(){
    return {
      personDatas:[],
      personPages:0,
      IP_TEST
    }
  },
  computed: {
  },
  beforeDestroy() {
  },
  created() {
   this.getGRMembers();
  },
  mounted(){
    this.$nextTick(()=>{
    })
  },
  methods: {
    async getGRMembers(){
      let result = await getGRMembers('','1');
      this.personDatas = result.data||[];
      this.personPages = Math.ceil( this.personDatas.length/6);
    }
  }
};
</script>
<style scoped>
.infonews .bigtitle {
  height: 34px;
  font-size: 36px;
  /* font-family: PingFang SC; */
  font-weight: bold;
  color: #004FB7;
  text-align: center;
  letter-spacing: 5px;
  margin-top: 45px;
  margin-bottom: 4px;
  background-image: url(/static/img/baito.png);
    background-repeat: no-repeat;
    background-position-y: 7px;
}

.personInfo li{
  width: 415px;
  height: 170px;
  display: inline-block;
  margin-top: 16px;
  margin-left:26px;
  border-radius: 5px;
  background-color: rgba(244, 249, 255, 1);
}
.personInfo li:first-child{
  margin-left:0px;
}
.personInfo li:nth-child(4n){
  margin-left:0px;
}
.personInfo li img{
  /* border-radius: 5px; */
  position: relative;
  top:15px;
  left: 15px;
}
.personInfo li .info{
  width:270px;
  display: inline-block;
  margin-left: 27px;
  padding: 20px 0;

}
.personInfo li h2{
  width: 226px;
  font-size: 18px;
/* font-family: PingFang SC; */
font-weight: 500;
-webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: block;
  cursor:pointer;
}
.personInfo li p{
  /* width: 226px; */
  margin-top:14px ;
font-weight: 500;
font-size: 13px;
font-family: PingFang SC;
font-weight: 500;
color: #2049B2;
-webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: block;
  cursor:pointer;
}
.personInfo li .sketch{
  height: 70px;
  line-height: 24px;
  -webkit-line-clamp: 3;
    font-size: 14px;
    white-space: normal;
    display: -webkit-box;
    margin-top:10px ;
}
.personInfo li .hengxian{
  width: 270px;
height: 1px;
background: #DDDDDD;
opacity: 0.3;
margin-top: 15px;
}
.personInfo ul{
  display: flex;
  flex-flow: row wrap;
}
</style>
